import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import * as d3 from 'd3';
import * as d3Scale from 'd3-scale';

import { Languages } from '@common/enum';

import { Dimensions, Config } from '../models';
@Injectable({
    providedIn: 'any'
})
export class ChartingService
{
    public dimensionsStore: BehaviorSubject<Dimensions>;
    private _dimensions: Dimensions;
    get dimensions (): Dimensions
    {
        return this._dimensions;
    }
    set dimensions (value: Dimensions)
    {
        this._dimensions = value;
        this.dimensionsStore.next(value);

        // this.xLeft = this._dimensions.marginLeft;
        // this.yTop = this._dimensions.marginTop;
        // this.boundedWidth = this._dimensions.boundedWidth;
        // this.boundedHeight = this._dimensions.boundedHeight;

        // this.configure();
    }
    // public xLeft: number;
    // public yTop: number;
    // public boundedWidth: number;
    // public boundedHeight: number;

    private _config: Config;
    get config (): Config
    {
        return this._config;
    }
    set config (value: Config)
    {
        const target = new Config();

        Object.assign(target, value);
        this._config = target;
        this.dimensions = this._config.dimensions;
        this.setD3Fmt();
    }

    private _fmt: d3.FormatLocaleObject = null;
    get fmt (): d3.FormatLocaleObject
    {
        return this._fmt;
    }

    get xTimeFormatTick (): (date: Date) => string
    {
        return d3.timeFormat(this.config.xFormatTick);
    }

    get yFormatTick (): (value: number) => string
    {
        return this.fmt.format(this.config.yFormatTick);
    }

    constructor ()
    {
        this.dimensionsStore = new BehaviorSubject<Dimensions>(new Dimensions());
    }

    public getXScaleBand ()
    {
        return d3Scale
            .scaleBand()
            .range([0, this.dimensions.boundedWidth])
            .paddingOuter(0.25)
            .paddingInner(0.25);
    }

    public getYScaleLinear ()
    {
        return d3Scale
            .scaleLinear()
            .rangeRound([this.dimensions.boundedHeight, 0]);
    }

    public getZScaleOrdinal (colors: string[])
    {
        return d3Scale
            .scaleOrdinal()
            .range(colors);
    }

    private setD3Fmt (): void
    {
        if (this._fmt === null)
        {
            if (this._config.language == Languages.frFr)
            {
                this._fmt = d3.formatLocale({
                    decimal: ',',
                    thousands: ' ',
                    grouping: [3],
                    currency: ['€', '']
                });
            }
            else
            {
                this._fmt = d3.formatLocale({
                    decimal: '.',
                    thousands: ',',
                    grouping: [3],
                    currency: ['€', '']
                });
            }
        }
    }
}
